import React, { useState, useEffect } from 'react'
import { Menu, Icon, Sidebar, Segment, Image, Grid, GridRow, GridColumn, Container, Checkbox } from 'semantic-ui-react'

import EditAccordionsComponent from './EditAccordions'

import { getQueryParam } from '/react4xp/utils/functions'

import './index.scss'

import type { AccordionItem } from './EditAccordions/index.d'

interface EmployeeManagerComponentProps {
    type: string
    images: {
        logo: string
    }
    services: {
        employeeManager: string
    }
    settings: {
        accordions: AccordionItem[]
        linkedin_url?: string
        researchgate_url?: string
    }
    profileLinks: {
        norwegian: string
        english: string
    }
    displayName: string
    accordionTitles: Array<{
        norwegian: string
        english: string
    }>
}

interface MenuItem {
    icon: string
    label: string
    type: string
}

export default function EmployeeManagerComponent(props: EmployeeManagerComponentProps) {
    const [currentType, setCurrentType] = useState(props.type || '');
    const [isPageLoaded, setIsPageLoaded] = useState(false);

    useEffect(() => {
        setCurrentType(getQueryParam('type'));

        // Wait for page to be fully loaded
        if (document.readyState === 'complete') {
            setIsPageLoaded(true);
        } else {
            const handleLoad = () => setIsPageLoaded(true);
            window.addEventListener('load', handleLoad);
            return () => window.removeEventListener('load', handleLoad);
        }
    }, []);

    const menuItems: MenuItem[] = [
    ];

    const [darkMode, setDarkMode] = useState(() => {
        return localStorage.getItem('darkMode') === 'true';
    });
    useEffect(() => {
        if (darkMode) {
            document.documentElement.classList.add('dark-mode');
            document.body.classList.add('dark-mode');
            localStorage.setItem('darkMode', 'true');
        } else {
            document.documentElement.classList.remove('dark-mode');
            document.body.classList.remove('dark-mode');
            localStorage.setItem('darkMode', 'false');
        }
    }, [darkMode]);

    return (
        <Sidebar.Pushable as={Segment} style={{ height: '100vh', margin: 0, border: 'none', borderRadius: 0 }}>
            <Sidebar
                as={Menu}
                animation='push'
                icon='labeled'
                inverted
                vertical
                visible={true}
            >
                <Menu.Item>
                    <Image src={props.images.logo} alt='logo' style={{ width: '100%', maxWidth: '180px', aspectRatio: '1/1' }} />
                </Menu.Item>
                {menuItems.map((item) => (
                    <Menu.Item
                        key={item.type}
                        as='a'
                        href={`?type=${item.type}`}
                        active={currentType === item.type}
                    >
                        <Icon name={item.icon} />
                        {item.label}
                    </Menu.Item>
                ))}
            </Sidebar>
            <Sidebar.Pusher className='sidebar-content' style={{ backgroundColor: darkMode ? '#111111' : '#FFF' }}>
                {isPageLoaded ? (
                    <>
                        <Container className='sidebar-content__container' fluid>
                            <Grid columns={1} >
                                <GridRow className='sidebar-content__row'>
                                    <GridColumn className='sidebar-content__column'>
                                        <EditAccordionsComponent accordions={props.settings.accordions} linkedin_url={props.settings.linkedin_url} researchgate_url={props.settings.researchgate_url} services={props.services} profileLinks={props.profileLinks} displayName={props.displayName} accordionTitles={props.accordionTitles} />
                                    </GridColumn>
                                </GridRow>
                            </Grid>
                        </Container>

                        {/* Dark / Light */}
                        <div className='dark-toggle'>
                            <Icon name='moon' />
                            <Checkbox
                                toggle
                                className='dark-toggle__checkbox'
                                aria-label='Toggle dark/light mode'
                                checked={darkMode}
                                onChange={() => setDarkMode(!darkMode)}
                            />
                            <Icon name='sun' />
                        </div>
                    </>
                ) : (
                    <div style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '100vh'
                    }}>
                        <div style={{
                            width: '40px',
                            height: '40px',
                            border: `3px solid ${darkMode ? '#343434' : '#e0e0e0'}`,
                            borderTop: `3px solid ${darkMode ? '#adadad' : '#333'}`,
                            borderRadius: '50%',
                            animation: 'spin 1s linear infinite'
                        }}></div>
                    </div>
                )}
            </Sidebar.Pusher>
        </Sidebar.Pushable>

    )
}
